import type {
  AdV5,
  CalculateCreativeDataAdDetailsInput,
  Get_Ads_By_Line_Item_IdsQuery,
} from '../../../../../../../../../../apis/graphql';
import { adStatuses, lineItemStatuses } from '../../../../../../../../../../configs';
import type { TargetingTermValue } from '../../../../../../../../../../models';
import type { LineItemModel } from '../../../../../../../../TraffickingPage/modelConverters';
import type { MultipleEditDrawerLineItemsFormValues } from '../../../../../../types';
import type { UseCheckConflictsParams } from '../../../types';
import { getMergedOldAndNewTargeting, transformTargetingTermValues } from '../../utils';

type NormalizedAds = {
  lineItemId?: LineItemModel['id'];
  hasActiveAd: boolean;
};

type AdNode = {
  node: Pick<AdV5, 'status'> & {
    lineItem: Pick<LineItemModel, 'id'> | null;
  };
};

export const getAds = (data?: Get_Ads_By_Line_Item_IdsQuery): NormalizedAds[] | undefined => {
  const getNormalizedAds = (acc: NormalizedAds[], { node }: AdNode): NormalizedAds[] => [
    ...acc,
    {
      lineItemId: node.lineItem?.id,
      hasActiveAd: node.status === adStatuses.ON.key,
    },
  ];

  return data?.ads.edges.reduce<NormalizedAds[]>(getNormalizedAds, []);
};

export const getLineItemsToBeActivated = (
  values: UseCheckConflictsParams['values']
): MultipleEditDrawerLineItemsFormValues['entities'] =>
  values.entities.filter((lineItemWithActivatedStatus) => {
    const originLineItem = values.initialStatuses.find((lineItem) => lineItem.id === lineItemWithActivatedStatus.id);

    return (
      lineItemWithActivatedStatus.status?.key === lineItemStatuses.ON.key &&
      originLineItem?.status?.key !== lineItemStatuses.ON.key
    );
  });

export const buildAdTargetingTermValues = (
  adIds: string[],
  newTargetingTermValues: TargetingTermValue[],
  filterTargetingWithEntityId?: Record<string, TargetingTermValue[]>
): CalculateCreativeDataAdDetailsInput[] => {
  if (!newTargetingTermValues.length) {
    return adIds.map((id) => ({ adId: id, targetingTermValues: [] }));
  }

  const inputTargeting = adIds.map((id) => ({
    id,
    value: transformTargetingTermValues(newTargetingTermValues),
  }));

  const merged = getMergedOldAndNewTargeting({
    inputTargeting,
    existedTargeting: filterTargetingWithEntityId,
  });

  return merged.map(({ id, value }) => ({
    adId: id,
    targetingTermValues: value,
  }));
};
